import 'maxkir/common/listeners';
import '../shift_shift_item'

export interface BookmarkItem extends ShiftShiftItem {
    url: string,
    last_used_at: number
}

interface BookmarksModel extends ShiftShiftModel {
    getFoundItems(): BookmarkItem[];

    hasNoData(): boolean;
}

let _current_text = null;
let _delayed_typing = null;
let _listeners = new maxkir.Listeners();

let _bookmarks_items: BookmarkItem[] = [];
let _reset_selection: boolean = false;

let _all_bookmarks_promise = null;
let _is_loading = false;

const accept_bookmark = (bookmark: maxkir_Bookmark, terms: string[]) => {
    return bookmark.matches_terms(terms);
}

const resort = (items: BookmarkItem[]) => {
    items.sort((a, b) => {
        let res;

        if (a.last_used_at && b.last_used_at && a.last_used_at !== b.last_used_at) {
            return b.last_used_at - a.last_used_at;
        }

        if (a.shortcut && b.shortcut) {
            res = a.shortcut.localeCompare(b.shortcut)
            if (res !== 0) {
                return res;
            }
        }
        else {
            if (a.shortcut) return -1;
            if (b.shortcut) return 1;
        }

        res = a.text.localeCompare(b.text);
        if (res !== 0) {
            return res;
        }
        return parseInt(a.id) - parseInt(b.id);
    })
}

const process_text_changed = (terms: string[]) => {

    _is_loading = true;
    get_bookmarks_data_promise().then((items: maxkir_Bookmark[]) => {
        _bookmarks_items = items
            .filter((bookmark) => accept_bookmark(bookmark, terms))
            .map((bookmark) => bookmark.to_item());
        resort(_bookmarks_items)
        _reset_selection = true;
        _is_loading = false;
        _listeners.notify_listeners_as_function();
    }, () => {
        _is_loading = false;
    });

}

const get_bookmarks_data_promise = function(): Promise<maxkir_Bookmark[]> {
    _all_bookmarks_promise = _all_bookmarks_promise ||
        (maxkir.Bookmarks ? maxkir.Bookmarks.load_bookmarks() : Promise.resolve([]));
    return _all_bookmarks_promise;
};

const model: BookmarksModel = {
    code: 'bookmarks',

    getFilterTerms(): string[] {
        return !_current_text ? [] : _current_text.split(/ +/);
    },

    hasNoData(): boolean {
        return maxkir.Bookmarks && maxkir.Bookmarks.hasNoData();
    },

    isLoading(): boolean {
        return _is_loading;
    },

    shouldResetSelection(): boolean {
        const res = _reset_selection;
        _reset_selection = false;
        return res;
    },

    onTextChanged(newText, delayProcessing: boolean) {
        _current_text = newText;
        if (!delayProcessing) {
            process_text_changed(this.getFilterTerms());
            return
        }

        if (!_delayed_typing) {
            _delayed_typing = maxkir.delay_action(() => {
                process_text_changed(this.getFilterTerms());
            }, 20);
        }
        _delayed_typing.start();
    },

    addDataAvailableCallback(callback) {
        _listeners.add_listener(callback)
    },

    removeDataAvailableCallback(callback) {
        _listeners.remove_listener(callback)
    },

    getFoundItems(): BookmarkItem[] {
        return _bookmarks_items;
    },

    dispose() {
        _all_bookmarks_promise = null;
        _bookmarks_items = [];
        _listeners.dispose();
    }
}

export default model;